import { Link } from "react-router-dom";
import { BRAND } from "../lib/brand";

export default function About() {
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-20" data-testid="about-page">
      <div className="text-xs uppercase tracking-widest text-[#1D4ED8]">About Zentry</div>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4 leading-[1.1]">
        Why Zentry exists.
      </h1>
      <p className="text-xl text-zinc-600 mt-8 max-w-3xl leading-relaxed">
        Real estate in India runs on a simple model: developers build, brokers sell, investors buy. The problem is that no one in this chain has an incentive to tell the investor when the investment doesn't make sense.
      </p>
      <p className="text-lg text-zinc-700 mt-6 max-w-3xl leading-relaxed">
        Developers need to sell inventory. Brokers need to earn commission. Portals need listings. Everyone benefits when you buy. No one benefits when you don't. <span className="font-medium text-zinc-900">Zentry was built to be the exception.</span>
      </p>

      <div className="mt-16 grid md:grid-cols-12 gap-10 items-start">
        <div className="md:col-span-5">
          <img src={BRAND.founder} alt={BRAND.founderName} className="rounded-3xl w-full border border-zinc-200" />
          <div className="mt-4">
            <div className="font-display text-2xl">{BRAND.founderName}</div>
            <div className="text-xs uppercase tracking-widest text-zinc-500 mt-1">Founder, Zentry</div>
          </div>
        </div>
        <div className="md:col-span-7">
          <h2 className="font-display text-3xl sm:text-4xl">The story</h2>
          <div className="mt-6 space-y-5 text-zinc-700 leading-relaxed">
            <p>Zentry was built by <span className="text-zinc-900 font-medium">Aman Thukral</span> who spent 10 years in advertising and events — building an eye for design, space, and what makes people feel something when they experience a place. When he moved into real estate, that background came along.</p>
            <p>After years in the industry, a pattern became impossible to ignore. Everyone was selling a developer's script. No research. No ground reality. Just guesswork dressed as opportunity. Brokers who had never invested their own money were advising people to put crores into properties based on a PowerPoint and a promise.</p>
            <p className="text-zinc-900 font-medium">Zentry was built because you cannot invest your hard-earned money on someone's guesswork.</p>
          </div>
        </div>
      </div>

      <div className="mt-24">
        <h2 className="font-display text-3xl sm:text-4xl">What Zentry does differently</h2>
        <div className="mt-8 grid md:grid-cols-2 gap-6">
          {[
            "Every recommendation is backed by ground-level market research — not developer brochures.",
            "We cover only markets we know — Goa and Uttarakhand for holiday homes, verified growth corridors for plots.",
            "We offer after-sales support — property management, rental management, and resale assistance.",
            "We tell you when not to invest. That honesty is what makes our 'yes' trustworthy.",
          ].map((t, i) => (
            <div key={i} className="bg-white border border-zinc-200 rounded-2xl p-6">
              <div className="font-display text-3xl text-[#1D4ED8]">0{i + 1}</div>
              <p className="text-zinc-700 mt-3">{t}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-24 bg-gradient-to-br from-[#1D4ED8] to-[#1E40AF] text-white rounded-3xl p-10 md:p-16 relative overflow-hidden">
        <div aria-hidden className="absolute -right-24 -top-24 w-[400px] h-[400px] rounded-full bg-white/10 blur-3xl pointer-events-none" />
        <div className="relative">
          <h3 className="font-display text-3xl sm:text-4xl leading-tight max-w-2xl">Have questions about your next investment?</h3>
          <p className="text-white/85 mt-4 max-w-xl">A 45-minute Clarity Call — no pressure, no developer on the line, no follow-up sales calls.</p>
          <Link to="/clarity-call" className="inline-flex items-center gap-2 bg-white text-[#1D4ED8] hover:bg-zinc-100 px-6 py-3 rounded-full font-medium mt-8">Book a Clarity Call</Link>
        </div>
      </div>
    </div>
  );
}
